// extracted by mini-css-extract-plugin
export default {"container":"_aef2e54b","hasTopMargin":"_2933b8e3","link":"_1a4fc5cc","moreOptionsIcon":"_f5727fc2"};